import React, { useState, useEffect } from 'react';
import "./NutzerVerwaltung.css";
import { useNavigate, useViewTransitionState } from 'react-router-dom';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Sidebar from '../../../components/Sidebar/Sidebar';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import { post } from '../../../Script/Session.js';
import { Token } from '../../../Script/Session.js';
import User from './components/User.jsx';

const NutzerVerwalten = () => {
    const navigate = useNavigate();
    const [wit, setwith] = useState("87.5%");
    const [loading, setLoading] = useState(true);
    function expand() {

    }
    function close() {

    }
    function search(event) {
        event.preventDefault();
        console.log("search");
        let value = document.getElementById("oshafhasdfj2141904890asf").value;
        if (value == " " || value == "") {
            cancelsearch();
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "search";
        body.term = value;
        let response = post(body, "/usermanagement");
        if (response == null) {
            alert("Fehler in der NutzerVerwaltung");
            return;
        }
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "NOPERMISSION") {
            alert("Fehlende Berechtigung");
            return;
        }
        console.log(response);
        let json = JSON.parse(response);
        setfilterdata(json.value);
    }


    function cancelsearch() {
        setfilterdata(data.value);
    }
    const [data, setdata] = useState({});
    const [filteredata, setfilterdata] = useState({});
    const [offset, setoffset] = useState(0);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                let body = {
                    token: Token.get(),
                    action: "get",
                    offset: offset,
                }
                let response = post(body, "/usermanagement")
                if (response == null) {
                    alert("Fehler in der NutzerVerwaltung");
                    navigate("/")
                    return;
                }
                if (response == "LOGOUT") {
                    navigate("/");
                    return;
                }
                if (response == "NOPERMISSION") {
                    alert("Fehlende Berechtigung");
                    return;
                }
                let json = JSON.parse(response);
                setdata(json);
                setfilterdata(json.value);
                console.log(json);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        // Delay fetch slightly to avoid blocking render
        setTimeout(() => {
            fetchData();
        }, 15); // Immediate but non-blocking
    }, [navigate]);
    const { menu, setmenu } = useState(false);

    const [deletedshow, setdeletedshow] = useState(false);
    function update(){
          let body = {
                    token: Token.get(),
                    action: "get",
                    offset: offset,
                }
                let response = post(body, "/usermanagement")
                if (response == null) {
                    alert("Fehler in der NutzerVerwaltung");
                    navigate("/")
                    return;
                }
                if (response == "LOGOUT") {
                    navigate("/");
                    return;
                }
                if (response == "NOPERMISSION") {
                    alert("Fehlende Berechtigung");
                    return;
                }
                let json = JSON.parse(response);
                setdata(json);
                setfilterdata(json.value);
                console.log(json);
    }

    return (
        <>
            <head><title>Verwaltung || Nutzer Verwalten</title></head>
            <div onMouseEnter={expand} onMouseLeave={close}><NavigationBar state="adminhome" back="inline" /></div>
            <div style={{ width: wit }} className='verwaltung-nutzer-container'>
                <div style={{
                    width: "95%",
                    backgroundColor: "#f7f7f7",
                    marginTop: "3.5%",
                    color: "white",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    overflow: "visible"
                }}>
                    <div style={{
                        width: "100%",
                        height: "55px",
                        backgroundColor: "#2a3042",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        fontSize: "20px",
                    }}>
                        <p>Nutzer Verwaltung</p>
                    </div>
                    <div
                        style={{
                            padding: "10px", width: "100%",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div style={{
                            backgroundColor: "transparent",
                            height: "60px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "black",
                        }}>
                            <form style={{ display: "flex", marginLeft: "1%", width: "30%", backgroundColor: "transparent", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }} onSubmit={search}>
                                <div style={{ display: "flex", marginRight: "5%", width: "120%" }} class="group">
                                    <svg class="icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg>
                                    <input onChange={e => {
                                        if (!document.getElementById("oshafhasdfj2141904890asf").value) {
                                            cancelsearch();
                                        }

                                    }} placeholder="Suchen" id="oshafhasdfj2141904890asf" type="search" class="input" />

                                </div>
                            </form>

                        </div>

                        <div style={{
                            backgroundColor: "transparent",
                            width: "98%",
                            borderStyle: "solid",
                            borderColor: "black",
                            borderWidth: "1px",
                            borderColor: "lightgray",
                        }}>
                            <div style={{
                                width: "100%",
                                height: "40px",
                                backgroundColor: "white",
                                display: "flex",
                                color: "black",
                                fontSize: "15px",
                                alignItems: "center",
                                fontWeight: "bold",
                                borderBottom: "1px solid darkgray",
                            }}>
                                <p style={{ marginLeft: "1.5%" }}>Informationen:</p>
                                <p style={{ marginLeft: "75%" }}>Bearbeiten:</p>
                            </div>

                            {loading ? (
                                <p>Loading groups...</p>
                            ) : filteredata.length === 0 ? (
                                <p style={{ marginLeft: "1%" }}>Keine Gruppe Gefunden</p>
                            ) : data.value.length > 0 ? (
                                <ul style={{ width: "100%", overflowY: "auto" }}>
                                    {filteredata
                                        .slice() // Kopie der Daten, um Original nicht zu verändern
                                        .sort((a, b) => a.locked - b.locked) // false (0) kommt vor true (1)
                                        .map((item, index) => (
                                            <li key={index} style={{ width: "100%" }}>
                                                <User
                                                    item={item}
                                                    setfilterdata={setfilterdata}
                                                    filterdata={filteredata}
                                                    groups={data.groups}
                                                    update={update}
                                                />
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                <p>No User available</p>
                            )}

                        </div>
                    </div>


                </div>


            </div>



        </>
    );



}
export default NutzerVerwalten;